import { useState } from "react";

export const useStepButtonScheduleDetail = () => {
  const [step, setStep] = useState(1);
  return { step, setStep };
};
